import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import HBoxSMS from 'hbox-sms';
import type { SMSManager } from 'hbox-sms';
import { API_CONFIG, PEP_V2_API_BASE } from '@/config/envConfig';

const SMSPage = () => {
  const { user, token, hasuraToken } = useAuth();
  const containerRef = useRef<HTMLDivElement>(null);
  const managerRef = useRef<SMSManager | null>(null);

  const hasAdvancedAccess = ['PA', 'CA', 'EA', 'ED'].includes(user?.type || '');
  useEffect(() => {
    document.title = "SMS | Admin";
  }, []);

  // Initialize SMS Manager
  useEffect(() => {
    if (containerRef.current && !managerRef.current && user && token && hasuraToken) {
      console.log('📱 Initializing HBox SMS Manager');
      
      managerRef.current = HBoxSMS.init('sms-container', {
        theme: 'light', // Can be made dynamic based on app theme
        loggedInUserId: parseInt(user.id),
        apiBaseUrl: API_CONFIG.API_BASE,
        graphqlBaseUrl: API_CONFIG.GRAPHQL_ENDPOINT,
        apiToken: token,
        graphqlToken: hasuraToken,
        key: 'PEP',
        hideTabs: hasAdvancedAccess ? [] : ['campaign', 'history'],
        pepVersion: PEP_V2_API_BASE,
      });

      console.log('✅ HBox SMS Manager initialized');
    }

    // Cleanup on unmount
    return () => {
      if (managerRef.current) {
        console.log('🧹 Cleaning up HBox SMS Manager');
        managerRef.current.destroy();
        managerRef.current = null;
      }
    };
  }, [user, token, hasuraToken]);

  return (
    <div className="min-h-screen bg-background">
      <main className="mx-auto">
        <div id="sms-container" ref={containerRef} />
      </main>
    </div>
  );
};

export default SMSPage;